/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserRole
 */
export interface UserRole {
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    readonly name?: string;
    /**
     * 
     * @type {number}
     * @memberof UserRole
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserRole
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof UserRole
     */
    client?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRole
     */
    userRights: Array<string>;
}

export function UserRoleFromJSON(json: any): UserRole {
    return UserRoleFromJSONTyped(json, false);
}

export function UserRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'label': json['label'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'client': !exists(json, 'client') ? undefined : json['client'],
        'userRights': json['user_rights'],
    };
}

export function UserRoleToJSON(value?: UserRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'description': value.description,
        'client': value.client,
        'user_rights': value.userRights,
    };
}


